
import { Button, Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from "@heroui/react";
import GrowthRecords from "@/features/Animals/GrowthRecords";

export default function Phase({ name, disabled, id, renderTrigger }: {
  name: string; disabled: boolean; id: string; phaseStage: any[]; animal: any;
  renderTrigger?: (props: { onPress: () => void; name: string }) => React.ReactNode;
}) {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  return <>
    {renderTrigger ? renderTrigger({ onPress: onOpen, name }) : <Button size="sm" isDisabled={disabled} onPress={onOpen}>{name}</Button>}
    <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="3xl" scrollBehavior="inside">
      <ModalContent><ModalHeader>Growth measurements</ModalHeader><ModalBody>
        <GrowthRecords animalId={id} />
      </ModalBody></ModalContent>
    </Modal>
  </>;
}
